import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorBoundary } from 'shared/components/error-boundary';
import { useBox } from 'shared/hooks/utils';
import { User } from 'z3k-config';
import { unpack_validation } from 'z3k-parser/validation/types';
import { memo, useCallback, useContext, useEffect, useMemo } from 'react';
import { Z3KSettingsEditor } from '../../provider/types';
import { TrustPhonesInput } from '../users/phones';
import { SettingContainer } from '../material-utils/settings-card/container';
import { Control } from 'console/shared/components/fields/control';
import { PasswordInput } from 'console/shared/components/fields/text/password';
export const TrustedNumbers = memo(function TrustedNumbers() {
    const { replace_config, config, validation_warnings_result, validation_result } = useContext(Z3KSettingsEditor);
    const user = useMemo(() => User.get.all(config)[0], [config]);
    useEffect(() => {
        if (user == null) {
            replace_config(User.get.addDefault(config)[1]);
        }
    }, []);
    const users_vr = useMemo(() => unpack_validation(validation_result, 'users'), [validation_result]);
    const users_vwr = useMemo(() => unpack_validation(validation_warnings_result, 'users'), [validation_warnings_result]);
    return (_jsx(ErrorBoundary, { children: user && (_jsx(TrustedNumbersContent, { user: user, users_vr: users_vr, users_vwr: users_vwr })) }));
});
export const TrustedNumbersContent = memo(function TrustedNumbersContent(props) {
    const { users_vr, users_vwr, user } = props;
    const { replace_config, config } = useContext(Z3KSettingsEditor);
    const configBox = useBox(config);
    const user_vr = useMemo(() => unpack_validation(users_vr, 0), [users_vr]);
    const user_vwr = useMemo(() => unpack_validation(users_vwr, 0), [users_vwr]);
    const onChangePassword = useCallback((new_password) => {
        replace_config(User.get.applySetterById(configBox.current, user.id, {
            password: new_password,
        }));
    }, []);
    const passwordVR = useMemo(() => unpack_validation(user_vr, 'password'), [user_vr]);
    const passwordVWR = useMemo(() => unpack_validation(user_vwr, 'password'), [user_vwr]);
    const onChangePhone = useCallback((new_phone) => {
        replace_config(User.get.applySetterById(configBox.current, user.id, {
            phone: new_phone,
        }));
    }, []);
    const phoneVR = useMemo(() => unpack_validation(user_vr, 'phone'), [user_vr]);
    const phoneVWR = useMemo(() => unpack_validation(user_vwr, 'phone'), [user_vwr]);
    return (_jsx(ErrorBoundary, { children: _jsxs(SettingContainer, { children: [_jsx(TrustPhonesInput, { value: user.phone, onChange: onChangePhone, validation_result: phoneVR, validation_warnings_result: phoneVWR }), _jsx("form", { autoComplete: "off", children: _jsx(Control, { label: "\u041F\u0430\u0440\u043E\u043B\u044C \u0434\u043B\u044F \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0441 \u0434\u0440\u0443\u0433\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430", field: PasswordInput, help_id: null, value: user.password, onChange: onChangePassword, validation_result: passwordVR, validation_warnings_result: passwordVWR }) })] }) }));
});
